// Redazione PII lato client, prima dell'invio. Specchio di `CloseYourIt::Scrubber`
// (gem) e `Scrubber` (dart): redige ricorsivamente i valori la cui **chiave**
// combacia con la denylist di campi sensibili.
//
// La denylist condivide il nucleo con backend/gem/dart
// (`pass|secret|token|api[_-]?key|apikey|authorization|cookie|csrf|credit|card|cvv|ssn|iban`)
// e aggiunge `email` — il browser è un contesto ad alto rischio PII e l'email è
// il dato personale più comune che finisce per errore in attributi/context. È un
// superset (più restrittivo), non un formato diverso: il backend ri-scruba comunque.

const SENSITIVE_KEY =
  /pass|secret|token|api[_-]?key|apikey|authorization|cookie|csrf|credit|card|cvv|ssn|iban|e[_-]?mail/i

// Assegnazione `chiave_sensibile=valore` (o `:`) dentro a un messaggio libero.
const SENSITIVE_ASSIGNMENT =
  /(?:pass|secret|token|api[_-]?key|apikey|authorization|cookie|csrf|credit|card|cvv|ssn|iban|e[_-]?mail)[\w-]*\s*[=:]\s*\S+/gi

export const FILTERED = '[FILTERED]'

/// `true` se la chiave è considerata sensibile (match parziale, case-insensitive).
export function isSensitiveKey(key: string): boolean {
  return SENSITIVE_KEY.test(key)
}

/// Copia profonda di [value] con i valori sensibili redatti. Una chiave che
/// combacia redige l'intero valore (anche mappe/liste); Map e Array annidati
/// vengono attraversati. Cicli protetti da `seen`.
export function scrub<T>(value: T, seen: WeakSet<object> = new WeakSet()): T {
  return scrubValue(value, seen) as T
}

function scrubValue(value: unknown, seen: WeakSet<object>): unknown {
  if (Array.isArray(value)) {
    if (seen.has(value)) return '[Circular]'
    seen.add(value)
    return value.map((item) => scrubValue(item, seen))
  }
  if (value !== null && typeof value === 'object') {
    if (seen.has(value)) return '[Circular]'
    seen.add(value)
    const input = value as Record<string, unknown>
    const result: Record<string, unknown> = {}
    for (const key of Object.keys(input)) {
      result[key] = isSensitiveKey(key) ? FILTERED : scrubValue(input[key], seen)
    }
    return result
  }
  return value
}

/// Redige le coppie `chiave_sensibile=valore` in un messaggio testuale libero
/// (es. il messaggio di un'eccezione), prima dell'invio.
export function scrubMessage(input: string): string {
  return input.replace(SENSITIVE_ASSIGNMENT, FILTERED)
}
